import {MStore} from '../../../master-files/m-store/model/m-store';
import {MBranch} from '../../../service/m-branch/model/m-branch';
import {TStockTransferItem} from './t-stocktransfer-item';

export class TStockTransfer {
  indexNo: number;
  inNumber: number = 0;
  outNumber: number= 0;
  inDate: string;
  outDate: string;
  fromBranch: MBranch;
  fromStore: MStore;
  toBranch: MBranch;
  toStore: MStore;
  refNumber: string;
  remarks: string;
  transactionType: string;
  transactionNumber: number;
  transactionDate: string;
  transactionStatus: string;
  tStockTransferItemList: TStockTransferItem [] = [];
}



// WEBPACK FOOTER //
// ./src/app/view/transactions/t-stock-transfer-out/model/t-stock-transfer.ts